(function (global) {
  'use strict';
  const pad = (value) => String(value).padStart(2, '0');
  const iso = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  function parse(value) {
    let parts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
    if (!parts) {
      const legacy = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(value || '');
      if (legacy) parts = [legacy[0], legacy[3], legacy[1], legacy[2]];
    }
    if (!parts) return null;
    const date = new Date(Number(parts[1]), Number(parts[2]) - 1, Number(parts[3]));
    return date.getFullYear() === Number(parts[1]) && date.getMonth() + 1 === Number(parts[2]) && date.getDate() === Number(parts[3]) ? date : null;
  }
  function minimum(now = new Date()) {
    return iso(new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1));
  }
  function error(value, now = new Date()) {
    const date = parse(value);
    if (!date) return 'Please choose a delivery date.';
    if (iso(date) < minimum(now)) return 'Please choose tomorrow or a later delivery date.';
    // Match the current live picker, including its fixed September 7 closure.
    if (date.getDay() === 0) return 'Delivery is unavailable on Sundays. Please choose another date.';
    if ((date.getMonth() === 0 && date.getDate() <= 3) || (date.getMonth() === 8 && date.getDate() === 7)) return 'Delivery is unavailable on this date. Please choose another date.';
    return '';
  }
  function legacy(value) {
    const date = parse(value);
    return date ? `${pad(date.getMonth() + 1)}/${pad(date.getDate())}/${date.getFullYear()}` : '';
  }
  const api = { parse, minimum, error, legacy, iso };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!global.document) return;
  api.validate = function (form, report = false) {
    const input = form?.querySelector('[data-delivery-date]');
    if (!input) return false;
    input.min = minimum();
    const message = error(input.value);
    input.setCustomValidity(message);
    form.querySelector('[name="attributes[date]"]').value = message ? '' : legacy(input.value);
    const feedback = form.querySelector('[data-delivery-error]');
    if (feedback) feedback.textContent = report ? message : '';
    if (report && message) input.reportValidity();
    return !message;
  };
  api.init = function () {
    const form = document.querySelector('#AvantCartForm');
    const input = form?.querySelector('[data-delivery-date]');
    if (!input) return;
    if (!input.dataset.initialized) {
      const saved = parse(form.querySelector('[name="attributes[date]"]').value);
      input.value = saved ? iso(saved) : '';
      input.dataset.initialized = 'true';
    }
    api.validate(form);
    form.querySelector('[name="checkout"]').disabled = false;
  };
  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-delivery-date]')) api.validate(event.target.form, true);
  });
  global.AvantDeliveryDate = api;
  api.init();
})(typeof window !== 'undefined' ? window : globalThis);
